module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "sp",
    attrs: {
      "id": "ch7"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "CT"
  }, [_vm._v("EXAMINATION")]), _vm._v(" "), _c('p', {
    staticClass: "CO"
  }, [_vm._v("For long moments the twelve of them stared silently at the display screen and its view of New Earth sliding slowly below them.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("Then Hazzard hauled himself to his feet. “I’d better go check out the ship’s systems.”")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("“The ship’s perfectly fine,” said Thornberry. “The automated safety program would’ve alerted us if anything was amiss.”")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("Hazzard nodded slowly. “Yeah, I know, but after eighty years I oughtta scan the screens. Automated maintenance and self-repair are okay, but I’ll feel better if I take a look for myself.”")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("As Hazzard went to the wardroom hatch, the team’s physician, Nara Yamaguchi, looked at her wristwatch and announced, “It’s three minutes before ten "), _c('span', {
    staticClass: "ePub-SC"
  }, [_vm._v("A.M.,")]), _vm._v(" ship time. If we start the physical exams immediately, we can get them finished before dinnertime.”")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("Her announcement was greeted by moans and grumbles. But Jordan said, “Dr. Yamaguchi has the responsibility of checking our physical conditions. Let’s cooperate with her, please.”")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("Yamaguchi made a stiff little bow to Jordan and said, with an almost impish grin, “Mr. Kell, you are first on my list.”")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("Rank hath its privileges, Jordan repeated to himself.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("Yamaguchi was a stubby, chubby young Japanese physician, a specialist in internal medicine. Her face was round, with a snub nose and eyes almost the color of bronze. Her hair was dull brown, chopped short in pageboy style. She was no beauty, yet she radiated intelligence and good humor, and she had the reputation of being an excellent diagnostician.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("Jordan followed her down the passageway to the ship’s small infirmary: little more than an examination table, a desk bearing a trio of display screens, and diagnostic scanners built into two of the walls and the ceiling. There were a couple of cubicles with beds in the next compartment, he remembered. Sitting on the examination table, Jordan removed his belt and shoes.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("“Anything metal in your pockets?” Yamaguchi asked.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("Jordan pulled the phone from his shirt pocket and handed it to the physician, who placed it on her desk. Funny, he thought. This instrument links me with the ship’s communications system, it’s a computer, a camera, a personal entertainment system, and a lot more, yet we still call it nothing more than a phone. The old name hangs on, despite all its varied functions.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("Yamaguchi instructed, “All right, just lie back and let the scanners go over you.”")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("Jordan looked up at the softly glowing light panels of the ceiling and listened to the soft hum of the machines behind them. He knew his body was being probed by X-rays, sculpted magnetic fields, positrons, and neutrinos. All in little more than the blink of an eye.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("“It’s a pretty soft life I’ve got,” Yamaguchi said as she sat at her desk, studying her readout screens. “The scanners do all the work, the computer makes the analysis, and I take the credit.”")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("“We’re a healthy bunch,” Jordan said. “Youngish … well, no one past middle age, physically. All of us are healthy. Or at least we were when we went into cryosleep.”")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("“Maybe too healthy,” Yamaguchi said.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("“I beg your pardon?”")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("“Four women, eight men. It could cause problems.”")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("Jordan felt surprised. He hadn’t felt any interest in sex since Miriam died. And the others … “The psych team passed on the arrangement,” he said.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("“They won’t be stuck here for five years.”")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("“Do you think there might be problems?”")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("“Probably not with Dr. Meek; he’s accustomed to bachelorhood. I don’t know about you, though.”")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("Jordan blinked with surprise. “I’ll be all right,” he said.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("“Sure you will,” she replied, with a mischievous grin. “Your brother seems to have paired up with Rudaki, and Verishkova followed Thornberry around all through our training classes like a puppy dog.”")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("“I didn’t realize,” Jordan admitted.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("“That leaves Hazzard, Zadar, de Falla, Longyear,” Yamaguchi ticked off on her fingers. “All young and physically fit. I’ll bet even I start to look good to them before very long.”")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("“There’s Trish Wanamaker.”")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("Yamaguchi nodded. “I can always put saltpeter in the drinking water.”")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("“Seriously?” Jordan gasped.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("She laughed. “We have much more effective medications. But I hope I won’t have to use them.”")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("Jordan nodded, wondering what would happen if the need to calm down some of the men arose.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("Yamaguchi returned her attention to her display screens. “You can sit up now.”")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("“Passed with flying colors?” Jordan asked as he bent down to reach for his shoes.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("“Almost,” Yamaguchi replied, peering at the readouts. She looked up at Jordan. “You’ve lost the pigmentation in your hair.”")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("“Yes. A bit disconcerting.”")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("“It’s not a problem, except cosmetically. But it is kind of strange.”")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("“I think it looks rather distinguished.”")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("Yamaguchi smiled minimally, but then she turned back to the screens. “There is something that concerns me, though.”")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("The virus, Jordan thought. It’s still detectable.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("He got to his feet, pulled on his belt, and took his phone from Yamaguchi’s desktop. The physician was intently studying her computer screens.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("“You were exposed to a bioengineered virus when you were in India,” Yamaguchi said, her eyes still on the screens.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("Jordan sagged back onto the exam table. “The biowar,” he said. “There were lots of gengineered bugs in the air.”")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("Yamaguchi nodded, then finally looked up at Jordan. “This one’s nestled in your small intestine.”")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("“It’s harmless,” said Jordan, with a confidence he did not truly feel. “The medics back on Earth concluded that it’s dormant and will remain so.”")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("“For how long?”")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("“Indefinitely, they told me.”")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("Yamaguchi said nothing, but her face had tightened into a concerned mask.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("“After all,” said Jordan, “I passed all the physical exams Earthside. They allowed me on this mission.”")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("Pointing at the central computer screen, Yamaguchi said, “Your record shows that your wife died of a similar virus.”")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("Jordan felt his face flame red.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("“Her immune system had already been compromised by a different infection,” he explained. “Mine wasn’t.”")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("“I’m sorry,” said Yamaguchi.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("“I’m really in fine health,” Jordan insisted.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("“Yes, so the scans show,” Yamaguchi admitted. “But your little hitchhiker worries me.”")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("“It’s dormant,” Jordan repeated.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("“For how long?” Yamaguchi asked again.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("“It’s been several years—not counting our time in cryosleep.”")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("“Cryogenic temperature didn’t harm it,” the physician muttered. “According to your file, the medical team back on Earth was hoping that the virus wouldn’t survive freezing.”")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("With a sardonic little smile, Jordan replied, “They used me and my hitchhiker for an experiment—to see what long-term cryonic immersion would do to the virus.”")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("“Didn’t bother it a bit,” Yamaguchi murmured.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("“Look, we have all sorts of bacteria and viruses in our bodies constantly, don’t we? Most of them don’t affect us at all. Some of them are even beneficial, aren’t they?”")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("“This one isn’t. It was designed to kill people.”")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("Like it killed Miriam, Jordan admitted silently. Aloud, he said, “Well, it hasn’t killed me.”")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("Yamaguchi didn’t reply, but the expression on her face said, "), _c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("Not yet.")])]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("“So what do you want to do, send me home?”")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("Yamaguchi almost laughed at the absurdity of that. “No,” she said. “As long as you’re asymptomatic there’s nothing we can do. Except…”")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("“Except?”")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("“Let me study the literature and see how much I can learn about these engineered viruses. Maybe there’s some way to destroy them.”")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("“Perhaps they have a built-in limit to their life spans,” Jordan suggested.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("Yamaguchi shook her head hard enough to make her hair swish back and forth. “No, no, no. They’re not nanomachines, with off-switches built into them. They’re viruses, alive but dormant. Not even stem-cell therapy can deal with them.”")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("“Perhaps nanomachines?” Jordan suggested.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("With a nod, Yamaguchi said, “Specifically designed to attack the virus and nothing else. That could work—if we had the nanotech facilities aboard ship.”")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("“Which we don’t,” Jordan said.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("“We can’t. Safety regulations. We can’t run the risk of having nanomachines infecting the ship.”")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("“Yet they use nanotechnology on the Moon. Out in the Asteroid Belt.”")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("“But not on Earth,” Yamaguchi said. “And not on this ship.”")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("“I suppose not,” Jordan sighed. “I’ll just have to live with the virus, the way I have been.”")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("Yamaguchi said, “I want to check you on a weekly basis. Make certain your little bugs are remaining dormant. And in the meantime I’ll see if there’s anything in the ship’s medical library that might help us get rid of them.”")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("“I’d appreciate that,” said Jordan. And he remembered Miriam’s final days. The pain. The unbearable pain.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-ec68b368","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/chapter7.vue
// module id = 96
// module chunks = 0